import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18 2C18.3797 2 18.6935 2.28215 18.7432 2.64823L18.75 2.75V4H21.5C22.0523 4 22.5 4.44772 22.5 5V21C22.5 21.5523 22.0523 22 21.5 22H3.5C2.94772 22 2.5 21.5523 2.5 21V5C2.5 4.44772 2.94772 4 3.5 4H6.25V2.64286C6.25 2.28782 6.58579 2 7 2C7.3797 2 7.69349 2.24185 7.74315 2.55563L7.75 2.64286V4H17.25V2.75C17.25 2.33579 17.5858 2 18 2ZM21 8.5H4V20.5H21V8.5ZM16.5 13.75C16.9142 13.75 17.25 14.0858 17.25 14.5C17.25 14.8797 16.9678 15.1935 16.6018 15.2432L16.5 15.25H8.5C8.08579 15.25 7.75 14.9142 7.75 14.5C7.75 14.1203 8.03215 13.8065 8.39823 13.7568L8.5 13.75H16.5ZM21 5.5H4V7H21V5.5Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }